import { UsersRound, Heart } from "lucide-react";
import {
  HERO_IMAGE,
  HERO_IMAGE_LIGHT,
  HERO_INTRO,
  ROSE_TL,
  ROSE_TR,
  ROSE_LIGHT_TL,
  ROSE_LIGHT_TR,
  LOGO_EMBLEM,
} from "@/data/services";

const Highlight = ({ Icon, title, sub }) => (
  <div className="flex items-center gap-3">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[color:var(--rs-gold)]/60 text-[color:var(--rs-gold)]">
      <Icon size={18} />
    </span>
    <div>
      <p className="text-xs font-semibold uppercase tracking-widest text-[color:var(--rs-gold)]">
        {title}
      </p>
      <p className="text-xs text-[color:var(--rs-muted)]">{sub}</p>
    </div>
  </div>
);

export const Hero = ({ theme }) => {
  const roseTL = theme === "dark" ? ROSE_TL : ROSE_LIGHT_TL;
  const roseTR = theme === "dark" ? ROSE_TR : ROSE_LIGHT_TR;
  return (
    <section id="forside" className="relative overflow-hidden">
      {/* Real gilded rose corners cropped from the brand artwork (per theme) */}
      <img
        src={roseTL}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute left-0 top-0 z-0 w-40 sm:w-56 lg:w-72"
      />
      <img
        src={roseTR}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-0 z-0 w-36 sm:w-52 lg:w-64"
      />

      <div className="relative z-10 mx-auto max-w-7xl px-6 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-12">
        {/* Centered crown/infinity logo, exactly like the poster */}
        <div className="flex flex-col items-center text-center">
          <img src={LOGO_EMBLEM} alt="Royal Solutions" className="h-16 w-auto sm:h-20" />
          <p className="mt-1 font-heading text-lg tracking-[0.3em] text-[color:var(--rs-text)]">
            ROYAL SOLUTIONS
          </p>
          <p className="text-[10px] uppercase tracking-[0.4em] text-[color:var(--rs-gold)]">
            Event Services
          </p>
        </div>

        {/* Two-column hero content */}
        <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <h1 className="font-heading text-4xl font-light leading-[1.05] tracking-tight text-[color:var(--rs-text)] sm:text-5xl lg:text-6xl">
              ROYAL <span className="text-[color:var(--rs-gold)]">SOLUTIONS</span>
            </h1>
            <p className="mt-3 text-xs uppercase tracking-[0.25em] text-[color:var(--rs-muted)] sm:text-sm">
              Professionel service &amp; eksklusive events
            </p>

            <div className="my-6 flex items-center gap-4">
              <span className="h-px w-12 bg-[color:var(--rs-gold)]/70" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--rs-gold)] sm:text-xs">
                Din all-in-one løsning
              </span>
            </div>

            <p className="max-w-xl text-sm leading-relaxed text-[color:var(--rs-muted)] sm:text-base">
              {HERO_INTRO}
            </p>

            <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:gap-10">
              <Highlight Icon={UsersRound} title="Kvalificeret team" sub="Vi skaber værdi" />
              <Highlight Icon={Heart} title="Din tilfredshed" sub="Er vores prioritet" />
            </div>
          </div>

          <div className="relative">
            <img
              src={theme === "dark" ? HERO_IMAGE : HERO_IMAGE_LIGHT}
              alt="Eksklusivt event dækket med guld og levende lys"
              className="h-72 w-full object-contain sm:h-96 lg:h-[520px]"
              style={{
                WebkitMaskImage:
                  "radial-gradient(100% 92% at 50% 46%, #000 42%, transparent 86%)",
                maskImage: "radial-gradient(100% 92% at 50% 46%, #000 42%, transparent 86%)",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
